<template>
    <div class="custom-select" tabindex="0" ref="customSelect">
        <div class="selected" :class="{ open: open }" @click="toggleDropdown">
            {{ selectedLabel || placeholder }}
        </div>
        <ul v-if="open" class="items">
            <li v-for="(option, index) in items" :key="option.id" @click="selectOption(option)" class="item">
                {{ option.value }}
                <b style="display:none;">{{index}}</b>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'CustomVSelect',
        props: {
            value: [String, Number, Object],
            items: {
                type: Array,
                default: () => []
            },
            placeholder: {
                type: String,
                default: ''
            },
            dense: {
                type: Boolean,
                default: false
            },
            solo: {
                type: Boolean,
                default: false
            },
            customClass: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                open: false,
                selectedLabel: null
            }
        },
        computed: {
            selectedOption() {
                const logItem = this.items.find(item => item.id === this.value) || null
               
                return logItem
            }
        },
        watch: {
            selectedOption(newOption) {
                this.selectedLabel = newOption ? newOption.value : this.placeholder
            },
            value(newValue) {
                this.selectedLabel = this.items.find(item => item.id === newValue)?.value || this.placeholder
            }
        },
        methods: {
            toggleDropdown() {
                this.open = !this.open
            },
            selectOption(option) {
                this.selectedLabel = option.value
                this.open = false
                this.$emit('input', option.id)
                this.$emit('change', option)
            },
            handleClickOutside(event) {
                const el = this.$refs.customSelect
                if (el && !el.contains(event.target)) {
                    this.open = false
                }
            }
        },
        mounted() {
            this.selectedLabel = this.selectedOption ? this.selectedOption.value : this.placeholder
            document.addEventListener('click', this.handleClickOutside)
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleClickOutside)
        }
    }
</script>

<style scoped>
    .custom-select {
        position: relative;
        width: 100%;
        cursor: pointer;
        height: 31px;
    }

    .custom-select .selected {
        background-color: #fff;
        border: 1px solid var(--v-primary-base) !important;
        color: var(--v-primary-base) !important;
        padding: 0 1em;
        border-radius: 20px;
        line-height: 35px;
        width: 50px;
    }

    .custom-select .selected.open {
        border-color: #ad8225;
        border-radius: 6px 6px 0 0;
    }

    .custom-select .selected::after {
        content: '';
        border: 5px solid transparent;
        border-top-color: var(--v-primary-base) !important;
        position: absolute;
        right: 2em;
        top: 18px;
    }

    .custom-select .items {
        position: absolute;
        display: inline-block;
        width: 50px;
        overflow-y: auto;
        overflow-x: hidden;
        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        border-radius: 4px;
        max-height: 304px;
        top: 0px;
        left: 0px;
        transform-origin: left top 0px;
        z-index: 8;
        padding-left: 0px !important;
        background: #fff;
        border: 1px solid #ccc;
    }

    .custom-select .items.show {
        display: block;
    }

    .custom-select .items .item {
        padding: 0 1em;
        color: var(--v-primary-base) !important;
        cursor: pointer;
    }

    .custom-select .items .item:hover {
        background-color: var(--v-navigation-darken2) !important;
    }

    .custom-select.dense .selected {
        height: 32px;
        line-height: 32px;
    }

    .custom-select.solo .items {
        border: 1px solid #ad8225
    }
</style>
